<template>
    <div v-if="websiteInfo" class="d-block w-100">
       <div class="d-flex align-items-center justify-content-between flex-wrap">
           <div class="d-flex align-items-center">
                <div>
                    <h3 class="page-title mb-md-0">
                        {{ websiteInfo.domain }}
                    </h3>
                    <div class="d-flex mt-1">
                        <d-badge v-if="websiteInfo.deprecated_at" pill class="badge-danger">Deprecated</d-badge>
                        <d-badge v-else pill class="badge-success">Active</d-badge>
                        <p class="mb-0 ml-2 font-weight-bold">
                            Currency: {{ websiteInfo.currency.code }}
                        </p>
                    </div>
                </div>

            </div>
            <div v-if="checkWebsitePermission(permissionTypes.websiteWriteSpecific, this.$route.params.id)" class="d-flex align-items-center mt-3 mt-sm-0">
                <button
                    @click="showEditModal"
                    class="btn btn-success d-flex align-items-center"
                >
                    <i class='fas fa-pencil-alt d-block'></i>
                    <span class="d-sm-none d-lg-block ml-2">
                        Edit domain
                    </span>
                </button>
                <confirm-message
                    :message="`You are about to delete your connection with ${websiteInfo.domain}.`"
                    :keep-button-text="`No, keep domain`"
                    @confirm="deleteWebsite"
                >
                    <button
                        class="btn btn-danger ml-3 d-flex align-items-center"
                    >
                        <i class='fas fa-trash d-block'></i>
                        <span class="d-sm-none d-lg-block ml-2">
                            Delete domain
                        </span>
                    </button>
                </confirm-message>
            </div>
        </div>
    </div>
</template>

<script>
import { UserService, WebsiteService } from '@/main';
import BagdeStatus from '@/helpers/bagde';
import notification from '@/mixins/notification';
import currency from '@/mixins/currency';
import ConfirmMessage from '@/components/common/confirmMessage.vue';
import permissions from '../../mixins/permissions';

export default {
    mixins: [currency, notification, permissions],
    components: {
        ConfirmMessage
    },

    data() {
        return {
            userInfo: [],
            websiteInfo: null,
        }
    },

    methods: {
        async deleteWebsite() {
            try {
                await WebsiteService.delete(this.$route.params.id)
                this.showNotification('success', 'Alert', 'Website successfully deleted!')
                this.$router.push('/dashboard')
                this.$router.go()
            } catch (e) {
                this.showNotification('warn', 'Alert', 'Can not delete website')
                console.log(e)
            }
        },

        getBadge(status) {
            return BagdeStatus.getBadgeType(status);
        },

        async getWebsite() {
            try {
                this.websiteInfo = await WebsiteService.getById(this.$route.params.id)
            } catch(e) {
                console.log(e)
            }
        },

        async getUserName() {
            try {
                this.userInfo = await UserService.getName()
            } catch(e) {
                console.log(e)
            }
        },

        showEditModal() {
            this.$modal.show('edit');
        },
    },

    created () {
        this.getWebsite()
        this.getUserName()
    },

    watch: {
        $route(to, from) {
            this.getWebsite()
        }
    },
};
</script>
